import React, { useEffect, useState } from "react";
import styles from "./parent-form.module.css";
import { Button, Spin, Typography } from "antd";
import { DEFAULT_IMAGE } from "../../constants/common";
import InformationForm from "./components/information_form/information_form";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import {
  getAllInstitutions,
  getAllLevels,
  parentSendOtp,
  saveParentForm,
} from "../../services/parent_form";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import ParentOtpModal from "./components/parent-otp-modal/parent-otp-modal";

const ParentForm = () => {
  const { institutionId } = useParams();
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit, reset, watch } = useForm();
  const [schoolDetailsData, setSchoolDetailsData] = useState(null);
  const [classData, setClassData] = useState([]);
  const [visibleOtp, setVisibleOtp] = useState(false);
  const [otpVerificationId, setOtpVerificationId] = useState(null);
  const formValues = watch();

  useEffect(() => {
    if (institutionId) {
      fetchInstitutionsDetails(institutionId);
    }
  }, []);

  useEffect(() => {
    if (schoolDetailsData) {
      fetchClass(schoolDetailsData.institution_name);
    }
  }, [schoolDetailsData]);

  const fetchClass = async () => {
    try {
      setLoading(true);
      const payload = {
        institution_name: schoolDetailsData.institution_name,
      };
      const response = await getAllLevels(payload);
      if (response?.data) {
        const data = response?.data?.data;
        setClassData(data);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchInstitutionsDetails = async () => {
    try {
      setLoading(true);
      const payload = {
        institution_id: institutionId,
      };
      const response = await getAllInstitutions(payload);
      if (response?.data) {
        const data = response?.data?.data?.schools[0];

        setSchoolDetailsData(data);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const submitAfterVerification = async () => {
    try {
      setLoading(true);
      const formData = formValues;
      const payload = {
        institution_id: institutionId,
        ...formData,
        student_date_of_birth: formData.student_date_of_birth
          ? dayjs(formData.student_date_of_birth).format("YYYY-MM-DD")
          : null,

        date_of_birth: formData.date_of_birth
          ? dayjs(formData.date_of_birth).format("YYYY-MM-DD")
          : null,
      };

      const response = await saveParentForm(payload);
      if (response?.data) {
        toast.success(response?.data?.message);
        reset();
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (formData) => {
    try {
      setLoading(true);
      const payload = {
        phone_number: formData?.phone_number,
        email: formData?.email,
        institution_id: institutionId,
      };
      const response = await parentSendOtp(payload);
      if (response?.data?.status) {
        setOtpVerificationId(response?.data?.data?.id);
        setVisibleOtp(true);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.top_box}>
      <div className={styles.upper_box}>
        <Spin spinning={loading}>
        {schoolDetailsData && (
          <div className={styles.main_box}>
            <div className={styles.headerContainer}>
              <Typography className={styles.title}>Parent Form</Typography>
            </div>
            <div className={styles.card_view}>
              <img
                src={schoolDetailsData.institution_logo || DEFAULT_IMAGE}
                alt="User Profile"
                height={80}
                width={80}
                style={{ borderRadius: "50%", objectFit: "cover" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = DEFAULT_IMAGE;
                }}
              />
              <div className={styles.view_name_and_id}>
                <Typography className={styles.school_name}>
                  {schoolDetailsData.institution_name}
                </Typography>
                <Typography className={styles.school_id}>
                  {`ID: ${schoolDetailsData.school_type} School`}
                </Typography>
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <InformationForm
                control={control}
                classes={classData}
                schoolName={schoolDetailsData.institution_name}
              />
              <div className={styles.button_view}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </div>
            </form>
          </div>
        )}
        </Spin>
      </div>
      <ParentOtpModal 
        visible={visibleOtp}
        onClose={() => setVisibleOtp(false)}
        formValues={{ ...formValues, institutionId }}
        otpVerificationId={otpVerificationId}
        setOtpVerificationId={setOtpVerificationId}
        submitAfterVerification={submitAfterVerification}
      />
    </div>
  );
};

export default ParentForm;
